import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    cursor: 'default',
    margin: '0.5em',
    backgroundColor: 'var(--color-white)',
    border: '1px solid rgba(61, 30, 92, 0.05)',
    borderRadius: '24px',
    boxShadow: '0 6px 18px rgba(61, 30, 92, 0.06)',
    overflow: 'hidden',
    position: 'relative',
    transition: 'transform .25s ease, box-shadow .25s ease, border-color .25s ease',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'var(--gradient-festive)',
      opacity: 0,
      transition: 'opacity .25s ease',
    },
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 22px 50px rgba(232, 72, 79, 0.18)',
      borderColor: 'rgba(255, 107, 107, 0.25)',
      opacity: 1,
    },
    '&:hover::after': {
      opacity: 1,
    },
    '&:hover $media': {
      transform: 'scale(1.04)',
    },
  },
  media: {
    minHeight: '160px',
    paddingTop: '56.25%',
    backgroundColor: 'var(--color-pink-blush)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transition: 'transform .35s ease',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0.5rem 1rem 1rem',
    '& button': {
      backgroundColor: 'var(--color-coral)',
      color: 'var(--color-white)',
      borderRadius: '999px',
      padding: '0.55rem',
      transition: 'transform .18s ease, background-color .18s ease, box-shadow .18s ease',
      boxShadow: '0 6px 18px rgba(232, 72, 79, 0.28)',
      '&:hover': {
        backgroundColor: 'var(--color-coral-deep)',
        transform: 'translateY(-1px) scale(1.05)',
        boxShadow: '0 10px 24px rgba(232, 72, 79, 0.38)',
      },
      '& svg': {
        fontSize: '1.25rem',
      },
    },
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '0.75rem',
    '& h3': {
      fontFamily: 'Inter, sans-serif',
      fontSize: '0.7rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: 'var(--color-coral)',
      margin: 0,
    },
    '& h4': {
      fontFamily: 'Fraunces, serif',
      fontSize: '1.55rem',
      fontWeight: 700,
      color: 'var(--color-plum)',
      letterSpacing: '-0.01em',
      margin: 0,
    },
  },
  cardSubtitle: {
    margin: '0.5rem 0 0.4rem',
    fontFamily: 'Fraunces, serif',
    fontSize: '1.1rem',
    fontWeight: 600,
    color: 'var(--color-plum)',
    lineHeight: 1.3,
    letterSpacing: '-0.005em',
  },
}));
